const emailjsdata = {
    service_id: "service_ap4qs8d",
    template_id: "template_gal9yt9",
    public_key: "0W9A215QYhR5U7l-4",
};

export default emailjsdata;